import React from 'react';
import './ProblemLocationSelected.css';

export default function ProblemLocationSelected({
  increaseFormStep,
  decreaseFormStep,
}) {
  return (
    <div className="pl-selected-body">
      <div className="pl-selected-text">
        Lokacija označena. Ukoliko želite promijeniti lokaciju kliknite na dugme
        nazad.
      </div>

      <div className="pl-selected-buttons">
        <button className="pl-selected-button" onClick={decreaseFormStep}>
          Nazad
        </button>
        <button className="pl-selected-button" onClick={increaseFormStep}>
          Dalje
        </button>
      </div>
    </div>
  );
}
